import React, { useMemo, useCallback } from "react";
import "./styles.less";
import { useTranslation } from "react-i18next";
import { logoLists } from "./customerList.js";
import { AuthingCarousel } from "../../components/AuthingCarousel";

export const Card = ({ item }) => {
  return (
    <>
      <div className="item-image-warp">
        <div className="item-logo">
          <img src={item.logo} alt={item.title} />
        </div>
        <div className="item-deco">
          <img
            src={item.cover || "//files.authing.co/authing-website/yinhao.png"}
            alt={item.title}
          />
        </div>
      </div>
      <div className="item-content-text">{item.content}</div>
      <div className="item-content-firm">{item.firm}</div>
    </>
  );
};

export const HomePageCustomer = () => {
  const { t } = useTranslation();
  const HoverText = useCallback(
    (item) => {
      return (
        <div className="customer-hover">
          <div
            className="customer-hover-inner"
            onClick={() => {
              if (item.clickUrl) {
                window.open(item.clickUrl);
              } else {
                window.open("https://www.authing.cn/customer");
              }
            }}
          >
            {item.clickUrl ? (
              <>
                {t("common.button.check-case")}
                <i
                  className="icon authing-icon authing-arrow-right-line"
                  style={{
                    display: "inline-block",
                    marginLeft: 6,
                    color: "inherit",
                    fontSize: 16,
                    position: "relative",
                    top: 0,
                  }}
                ></i>
              </>
            ) : (
              t("common.button.expect")
            )}
          </div>
        </div>
      );
    },
    [t]
  );
  const productLists = useMemo(() => {
    return [
      {
        title: "pingcap",
        logo: "//files.authing.co/authing-website/home-logo-new-16.png",
        content: t("homePage.customer.productLists1.content"),
        firm: t("homePage.customer.productLists1.firm"),
        clickUrl: "https://www.authing.cn/customer/pingcap",
      },
      {
        title: "BOSCH",
        logo: "//files.authing.co/authing-website/home-logo-new-12.png",
        content: t("homePage.customer.productLists2.content"),
        firm: t("homePage.customer.productLists2.firm"),
        clickUrl: "https://www.authing.cn/customer/bosch", // 跳转地址
      },
      {
        title: t("homePage.customer.productLists3.title"),
        logo: "//files.authing.co/authing-website/home-logo-new-14.png",
        content: t("homePage.customer.productLists3.content"),
        firm: t("homePage.customer.productLists3.firm"),
        clickUrl: "", // 跳转地址
      },
      {
        title: "Bentley",
        logo: "//files.authing.co/authing-website/home-logo-new-11-t.png",
        content: t("homePage.customer.productLists4.content"),
        firm: t("homePage.customer.productLists4.firm"),
        clickUrl: "https://www.authing.cn/customer/bentley", // 跳转地址
      },
      {
        title: "CSDN",
        logo: "//files.authing.co/authing-website/home-logo-new-17.png",
        content: t("homePage.customer.productLists5.content"),
        firm: t("homePage.customer.productLists5.firm"),
        clickUrl: "https://www.authing.cn/customer/csdn",
      },
    ];
  }, [t]);
  return (
    <>
      <div className="home-page-customer">
        <div className="basic-column">
          <div className="home-page-customer-title basic-title">
            {t("homePage.customer.title")}
          </div>
          <AuthingCarousel list={productLists} Card={Card}></AuthingCarousel>
          <div className="home-page-customer-logo-warp">
            <div className="scroll-mask"></div>
            {[logoLists[0], logoLists[1]].map((lists) => {
              return (
                <div className="scroll-container">
                  {lists.map((item, index) => {
                    return (
                      <div key={index} className="customer-item">
                        <div className="customer-logo">
                          <img src={item.logo} alt={item.name} />
                        </div>
                        {HoverText(item)}
                      </div>
                    );
                  })}
                  {lists.map((item, index) => {
                    return (
                      <div key={`${index}-copy`} className="customer-item">
                        <div className="customer-logo">
                          <img src={item.logo} alt={item.name} />
                        </div>
                        {HoverText(item)}
                      </div>
                    );
                  })}
                </div>
              );
            })}
          </div>
        </div>
      </div>
    </>
  );
};
